import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ServiceApi } from "../../../services/index.service";
import { enqueueSnackbar } from "notistack";

const useMenu = () => {
  const [productsList, setProductsList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [origProductsList, setOrigProductsList] = useState([]);
  const [store, setStore] = useState(null);
  const [loadingButton, setLoadingButton] = useState("");
  const serviceapi = new ServiceApi();
  const { storage } = useSelector((state) => state);
  useEffect(() => {
    if (store) {
      fetchProducts();
    }
  }, [store]);

  useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);

  const fetchProducts = async () => {
    setLoading(true);
    const res = await serviceapi.getMenusList(store?.intStoreID);
    console.log(res?.data);
    setLoading(false);
    setProductsList(res?.data?.products_data);
    setOrigProductsList(res?.data?.products_data);
    const check= res?.data?.products_data?.filter(i=> !i?.bitMasterProduct && !i?.bitActive)
    if(check?.length ===0){
      setSelectAll(true)
    }
  };

  const handleChange = (productId, val) => {
    const mainData = [...productsList];
    const res = mainData?.map((i) => {
      if (i.intProductTypeID === productId) {
        return { ...i, bitMasterProduct: val };
      }
      return { ...i };
    });
    setProductsList(res);
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    const mainData = [...productsList];
    const res = mainData?.map((i) => {
      return { ...i, bitMasterProduct: !selectAll };
    });
    setProductsList(res);
  };

  const handleReset = () => {
    setSelectAll(false);
    setProductsList(origProductsList);
    const check= origProductsList?.filter(i=> !i?.bitMasterProduct && !i?.bitActive)
    if(check?.length ===0){
      setSelectAll(true)
    }
  };

  const handleSave = async () => {
    const req = {
      intStoreID: store?.intStoreID,
      products_data:productsList
    };
    setLoadingButton(true);
    const res = await serviceapi.saveMenusList(req);
    setLoadingButton(false);
    if (res?.statusCode === 200 || res) {
      enqueueSnackbar("Updated Products List Successfully", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      setSelectAll(false);
      await fetchProducts()
    } else {
      enqueueSnackbar("Error in Updating Products List", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
    }
  };
  return {
    handleSelectAll,
    handleReset,
    handleSave,
    handleChange,
    loading,
    loadingButton,
    store,
    selectAll,
    productsList,
  };
};

export default useMenu;
